import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useToast } from '../context/ToastContext';
import './QuickViewModal.css';

const QuickViewModal = ({ product, isOpen, onClose }) => {
  const { addToCart } = useCart();
  const { success, error } = useToast();

  if (!isOpen || !product) return null;

  const handleAddToCart = async () => {
    try {
      await addToCart(product);
      success(`${product.name} added to cart!`);
      onClose();
    } catch (err) {
      error(err.message || 'Failed to add to cart');
    }
  };

  return (
    <div className="quickview-overlay" onClick={onClose}>
      <div className="quickview-modal" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        
        <div className="quickview-content">
          <div className="quickview-image">
            <img src={product.image} alt={product.name} />
          </div>
          
          <div className="quickview-info">
            <div className="quickview-header">
              {product.badge && <span className="product-badge">{product.badge}</span>}
              <h2>{product.name}</h2>
              <div className="quickview-rating">
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className={`fas fa-star ${i < 4 ? 'active' : ''}`}></i>
                  ))}
                </div>
                <span>({product.reviews} reviews)</span>
              </div>
            </div>
            
            <div className="quickview-price">
              <span className="current-price">₹{product.price}</span>
            </div>
            
            <p className="quickview-description">{product.description}</p>
            
            <div className="quickview-options">
              {(() => {
                const defaultSizes = ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
                const sizesToShow = (product.category === 'T-Shirts' || product.category === 'Hoodies' || product.category === 'Alumni Kits') 
                  ? defaultSizes 
                  : (product.sizes || ['One Size']);
                return sizesToShow.length > 0 && (
                  <div className="option-group">
                    <label>Size:</label>
                    <div className="size-chips">
                      {sizesToShow.map(size => (
                        <span key={size} className="size-chip">{size}</span>
                      ))}
                    </div>
                  </div>
                );
              })()}
              
              {product.colors && product.colors.length > 0 && (
                <div className="option-group">
                  <label>Color:</label>
                  <div className="color-chips">
                    {product.colors.map(color => (
                      <span 
                        key={color} 
                        className="color-chip" 
                        title={color}
                        style={{ backgroundColor: color.toLowerCase() }}
                      ></span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            <div className="quickview-actions" style={{ display: 'flex', gap: '12px' }}>
              <Link to={`/product/${product.dbId || product.id}`} className="view-details-btn" style={{ flex: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <i className="fas fa-eye"></i> View Full Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickViewModal;
